type handler = (state: any, action: Action.Sync) => any;

interface iAsyncHandler {
    init: handler;
    succeeded: handler;
    failed: handler;
}

// 创建同步Action Handler
export const createActionHandler = (type: string, handler: handler) => {
    return {
        [type]: handler
    };
};

// 创建异步Action Handler
export const createAsyncActionHandler = (type: string, handlers: iAsyncHandler) => {
    return {
        [type]: handlers.init,
        [`${type}_SUCCEEDED`]: handlers.succeeded,
        [`${type}_FAILED`]: handlers.failed
    };
};
